import { autoserializeAs, inheritSerialization } from 'cerialize';
import { Driver } from './driver';
import { FavoriteLocation } from './favorite-location';

import { Person } from './person';
import { RiderRidePreferences } from './rider-ride-preferences';

@inheritSerialization(Person)
export class Rider extends Person {
  @autoserializeAs(Driver)
  favoriteDrivers: Array<Driver>;

  @autoserializeAs(FavoriteLocation)
  favoriteLocations: Array<FavoriteLocation>;

  @autoserializeAs(RiderRidePreferences)
  ridePreferences: RiderRidePreferences;

  ignoredDrivers: Array<Driver> = [];
}
